define.alias("shared/utils/time-slot-utils", "calendar/utils/time-slot-utils");